module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v("The River ")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ctc",
    attrs: {
      "id": "p0011-01-0"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "pagexi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/chapter2#p0009-P-1"
    }
  }, [_vm._v("A Note from the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0011-02-1"
    }
  }, [_c('span', [_c('i', [_vm._v("“If stories come to you, care for them. And learn to give ")]), _c('i', [_vm._v("them away where they are needed. Sometimes a person ")]), _c('i', [_vm._v("needs a story more than food to stay alive.” ")])])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    attrs: {
      "id": "p0011-02-2"
    }
  }, [_c('span', [_vm._v("—Barry Lopez, in "), _c('i', [_vm._v("Crow and Weasel "), _c('br'), _c('br'), _c('br')])])]), _vm._v(" "), _c('p', {
    staticClass: "txz",
    attrs: {
      "id": "p0011-03-3"
    }
  }, [_c('span', [_vm._v("I’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VE ALWAYS LOVED TO TELL STORIES, ESPECIALLY ")]), _vm._v("with friends or family. I love sharing the fun of an unlikely event, a self-deprecating faux pas, or a whimsical conversation with one of my kids. There’s nothing like a great story.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-04-5"
    }
  }, [_c('span', [_vm._v("My grandfather was a wonderful storyteller. I used to sit next to his wood-burning stove with a Chek Root Beer float in hand, listening to him tell me about his childhood. He described the hardships of growing up during the Great Depression, how he used to build Goodyear blimps, and how his personally customized RV always broke down at the top of some mountain pass in the harshest of winters.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-01-0"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "pagexii"
    }
  }, [_vm._v("I never really cared whether his stories were based on fact or fiction. I just loved getting lost in the magic of his words. It was as if I could experience those adventures and relationships too, even though I was only eight years old.")])])]), _c('a', {
    attrs: {
      "id": "pagexii"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-01-1"
    }
  }, [_c('span', [_vm._v("The story I’m about to tell you is inspired by a collage of events, conversations, and happenings in my life and the life of my family. I believe you’ll find some of your story here as well. I’m not sure how that happens, but it always does.")])]), _vm._v(" "), _c('p', {
    staticClass: "txr",
    attrs: {
      "id": "p0012-02-3"
    }
  }, [_c('span', [_vm._v("Michael Neale "), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "txr1",
    attrs: {
      "id": "p0012-02-3s"
    }
  }, [_c('span', [_vm._v("2012")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecd64646","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter3.vue
// module id = 72
// module chunks = 0